import React from "react";
import Popover from "../Popover";

export default function HelpPopover() {
  return (
    <Popover triggerText="Help">
      <Popover.Title>CAVS Help</Popover.Title>
      <Popover.Body>
        For assistance with any CAVS questions please
        email <a href="mailto:help@reason.consulting" target="_blank">help@reason.consulting</a>.
        Please include the browser you are using and a description of the
        issue along with a screen shot.
      </Popover.Body>
    </Popover>
  );
};
